<template>
  <div class="oj_match">
    <!-- 搜索 -->
    <div class="select">
      <el-row>
        <el-col :span="20"
          ><div class="grid-content bg-purple">
            <el-form
              :inline="true"
              :model="selectForm"
              class="demo-form-inline"
              @submit.native.prevent
            >
              <el-form-item label="">
                <el-input
                  v-model="selectForm.keyword"
                  placeholder="请输入标题或id"
                  clearable
                  @clear="handleClear"
                  @keyup.enter.native="onSelect"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onSelect">搜索</el-button>
              </el-form-item>
            </el-form>
          </div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple">&nbsp;</div></el-col
        >
        <el-col :span="2"
          ><div class="grid-content bg-purple-light">
            <div class="cratebtn">
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="createOpen"
                >{{ createTitle }}</el-button
              >
            </div>
          </div></el-col
        >
      </el-row>
    </div>
    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      border
      v-loading="loading"
      style="width: 100%"
    >
      <el-table-column
        fixed
        prop="contest_id"
        label="ID"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="title"
        :label="tableTitle"
        width="160"
      ></el-table-column>
      <el-table-column prop="start_time" label="开始时间"> </el-table-column>
      <el-table-column prop="end_time" label="结束时间"> </el-table-column>
      <el-table-column prop="defunct" label="公开/私有">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.private == 0">公开</el-tag>
          <el-tag type="warning" v-if="scope.row.private == 1">私有</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="defunct" label="是否上线/屏蔽">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.defunct == 'N'"
            type="success"
            @click="isDefunct(scope.row.contest_id)"
            >上线中</el-button
          >
          <el-button
            v-if="scope.row.defunct == 'Y'"
            type="warning"
            @click="isDefunct(scope.row.contest_id)"
            >已下线</el-button
          >
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="300">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <el-button
              type="primary"
              icon="el-icon-view"
              size="small"
              @click="handleLookClick(scope.row.contest_id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <el-button
              type="success"
              icon="el-icon-edit"
              size="small"
              @click="
                editorOpen(scope.row.contest_id, '/v1/contest/save', '编辑')
              "
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="日志下载"
            placement="top"
          >
            <el-button
              type="info"
              icon="el-icon-document"
              size="small"
              @click="handleLogDClick(scope.row.contest_id)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="small"
              @click="handleDeleteClick(scope.row.contest_id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pages">
      <div class="block">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="sizes"
          :page-size="sizePage"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 查看弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="lookDialogVisible"
      width="50%"
      :lock-scroll="false"
      @closed="closed('lookForm')"
    >
      <el-form
        :label-position="'lift'"
        :model="lookForm"
        label-width="140px"
        ref="lookForm"
      >
        <el-form-item label="ID：">
          <el-tag>{{ lookForm.contest_id }}</el-tag>
        </el-form-item>
        <el-form-item label="形式：">
          <el-tag v-if="lookForm.type == '1'">比赛</el-tag>
          <el-tag v-if="lookForm.type == '2'">测验</el-tag>
        </el-form-item>
        <el-form-item :label="tableTitle + '-标题：'">
          <el-tag>{{ lookForm.title }}</el-tag>
        </el-form-item>
        <el-form-item :label="tableTitle + '-开始于：'">
          <el-tag>{{ lookForm.start_time }}</el-tag>
        </el-form-item>
        <el-form-item :label="tableTitle + '-结束于：'">
          <el-tag>{{ lookForm.end_time }}</el-tag>
        </el-form-item>
         <el-form-item :label="tableTitle + '-时长：'">
          <el-tag>{{ lookForm.duration }}</el-tag>
        </el-form-item>
        <el-form-item :label="'报名' + '-开始于：'">
          <el-tag>{{ lookForm.reg_start_time }}</el-tag>
        </el-form-item>
        <el-form-item :label="'报名' + '-结束于：'">
          <el-tag>{{ lookForm.reg_end_time }}</el-tag>
        </el-form-item>
        <el-form-item :label="tableTitle + '题目-描述：'">
          <span v-html="lookForm.description"> </span>
        </el-form-item>

        <el-form-item :label="tableTitle + '题目-编号：'">
          <el-tag>{{ lookForm.cproblem || "无" }}</el-tag>
        </el-form-item>

        <el-form-item :label="tableTitle + '题目-公开/私有：'">
          <el-tag v-if="lookForm.private === 0">公开</el-tag>
          <el-tag v-if="lookForm.private === 1">私有</el-tag>
        </el-form-item>
        <el-form-item :label="tableTitle + '-语言：'">
          <el-tag>{{ lookForm.lang || "无" }}</el-tag>
        </el-form-item>
        <el-form-item
          v-if="this.lookForm.private === '0' ? false : true"
          :label="tableTitle + '-密码：'"
          prop="password"
        >
          <el-tag>{{ lookForm.password || "无" }}</el-tag>
        </el-form-item>
        <el-form-item
          v-if="this.lookForm.private === '0' ? false : true"
          :label="tableTitle + '-用户：'"
        >
          <el-tag>{{ lookForm.users || "无" }}</el-tag>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="lookDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑弹出框 -->
    <el-dialog
      :title="title"
      :visible.sync="EditorDialogVisible"
      width="66%"
      :lock-scroll="false"
      @closed="closed('editorForm')"
    >
      <el-form
        :label-position="'lift'"
        :model="editorForm"
        label-width="120px"
        :rules="ruleFrom"
        ref="editorForm"
        :validate-on-rule-change="false"
      >
        <el-form-item label="形式" prop="type">
          <el-radio-group v-model="editorForm.type">
            <el-radio label="1">比赛</el-radio>
            <el-radio label="2">测验</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="tableTitle + '-标题'" prop="title">
          <el-input
            v-model="editorForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple">
              <el-form-item :label="tableTitle + '-开始于'" prop="start_time">
                <DatePicker
                  v-if="EditorDialogVisible"
                  :initDate="editorForm.start_time"
                  @change="getNowDate($event, editorForm, 'start_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
          <el-col :span="12"
            ><div class="grid-content bg-purple-light">
              <el-form-item :label="tableTitle + '-结束于'" prop="end_time">
                <DatePicker
                  v-if="EditorDialogVisible"
                  :initDate="editorForm.end_time"
                  @change="getNowDate($event, editorForm, 'end_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
        </el-row>
         <el-form-item :label="tableTitle + '-时长'" prop="duration">
          <el-time-picker
              name="时长"
              v-model="editorForm.duration"
              :picker-options="{selectableRange: '00:00:00 - 23:59:59',}"
              placeholder="任意时间点"
              value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
        <!-- 报名 -->
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple">
              <el-form-item :label="'报名' + '-开始于'" prop="reg_start_time">
                <DatePicker
                  v-if="EditorDialogVisible"
                  :initDate="editorForm.reg_start_time"
                  @change="getNowDate($event, editorForm, 'reg_start_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
          <el-col :span="12"
            ><div class="grid-content bg-purple-light">
              <el-form-item :label="'报名' + '-结束于'" prop="reg_end_time">
                <DatePicker
                  v-if="EditorDialogVisible"
                  :initDate="editorForm.reg_end_time"
                  @change="getNowDate($event, editorForm, 'reg_end_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
        </el-row>
        <!-- 下拉题目编号 -->
        <!-- <el-form-item :label="tableTitle + '题目-编号'" prop="cproblem">
          <el-select
            v-model="editorForm.cproblem"
            multiple
            filterable
            placeholder="请选择或输入搜索项"
          >
            <el-option
              v-for="item in problemList"
              :key="item.problem_id"
              :label="item.problem_id + '-' + item.title"
              :value="item.problem_id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="tableTitle + '题目-编号'" prop="cproblem">
          <el-input
            v-model="editorForm.cproblem"
            placeholder="请输入题目编号"
          ></el-input>
        </el-form-item>
        <el-form-item :label="tableTitle + '题目-描述'" prop="description">
          <Editor
            v-if="EditorDialogVisible"
            :heigth="300"
            :editorID="'Editor_editor_match'"
            :html="editorForm.description"
            @change="editorChange($event, editorForm, 'description')"
          ></Editor>
        </el-form-item>
        <el-form-item :label="tableTitle + '-语言'" prop="lang">
          <el-select
            v-model="editorForm.lang"
            multiple
            filterable
            placeholder="请选择或输入搜索项"
          >
            <el-option
              v-for="(item, key) in languageList"
              :key="key"
              :label="item"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="tableTitle + '-公开/私有'" prop="private">
          <el-select v-model="editorForm.private" placeholder="请选择">
            <el-option value="0" label="公开"></el-option>
            <el-option value="1" label="私有"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.editorForm.private === '0' ? false : true"
          :label="tableTitle + '-密码'"
        >
          <el-input
            placeholder="请输入私有比赛密码"
            v-model="editorForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="this.editorForm.private === '0' ? false : true"
          :label="tableTitle + '-用户'"
          prop="ulist"
        >
          <el-input
            type="textarea"
            autosize
            placeholder="请输入用户 多个用户请使用英文逗号隔开"
            v-model="editorForm.users"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditorDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleEditorSubmit('editorForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 新增的弹出框 -->
    <el-dialog
      width="66%"
      :title="title"
      :visible.sync="createEventDialog"
      :lock-scroll="false"
      @closed="closed('submitForm')"
    >
      <el-form
        :model="newCreateForm"
        label-width="120px"
        :rules="ruleFrom"
        ref="submitForm"
        :validate-on-rule-change="false"
      >
        <el-form-item label="形式" prop="type">
          <el-radio-group v-model="newCreateForm.type">
            <el-radio label="1">比赛</el-radio>
            <el-radio label="2">测验</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="tableTitle + '-标题'" prop="title">
          <el-input
            v-model="newCreateForm.title"
            placeholder="请输入标题"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple">
              <el-form-item :label="tableTitle + '-开始于'" prop="start_time">
                <DatePicker
                  v-if="createEventDialog"
                  @change="getNowDate($event, newCreateForm, 'start_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
          <el-col :span="12"
            ><div class="grid-content bg-purple-light">
              <el-form-item :label="tableTitle + '-结束于'" prop="end_time">
                <DatePicker
                  v-if="createEventDialog"
                  @change="getNowDate($event, newCreateForm, 'end_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
        </el-row>
        <el-form-item :label="tableTitle + '-时长'" prop="duration">
          <el-time-picker
              name="时长"
              v-model="newCreateForm.duration"
              :picker-options="{selectableRange: '00:00:00 - 23:59:59',}"
              placeholder="任意时间点"
              value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
        <!-- 报名 -->
        <el-row>
          <el-col :span="12"
            ><div class="grid-content bg-purple">
              <el-form-item :label="'报名' + '-开始于'" prop="reg_start_time">
                <DatePicker
                  v-if="createEventDialog"
                  @change="getNowDate($event, newCreateForm, 'reg_start_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
          <el-col :span="12"
            ><div class="grid-content bg-purple-light">
              <el-form-item :label="'报名' + '-结束于'" prop="reg_end_time">
                <DatePicker
                  v-if="createEventDialog"
                  @change="getNowDate($event, newCreateForm, 'reg_end_time')"
                ></DatePicker>
              </el-form-item></div
          ></el-col>
        </el-row>
        <!-- 下拉题目编号 -->
        <!-- <el-form-item :label="tableTitle + '题目-编号'" prop="cproblem">
          <el-select
            v-model="newCreateForm.cproblem"
            multiple
            filterable
            placeholder="请选择或输入搜索关键字"
          >
            <el-option
              v-for="item in dataPool"
              :key="item.problem_id"
              :label="item.problem_id + '-' + item.title"
              :value="item.problem_id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="tableTitle + '题目-编号'" prop="cproblem">
          <el-input
            v-model="newCreateForm.cproblem"
            placeholder="请输入题目编号"
          ></el-input>
        </el-form-item>
        <el-form-item :label="tableTitle + '题目-描述'" prop="description">
          <Editor
            v-if="createEventDialog"
            :heigth="300"
            :editorID="'Editor_create_match'"
            @change="editorChange($event, newCreateForm, 'description')"
          ></Editor>
        </el-form-item>
        <el-form-item :label="tableTitle + '-语言'" prop="lang">
          <el-select
            v-model="newCreateForm.lang"
            multiple
            filterable
            placeholder="请选择或输入搜索项"
          >
            <el-option
              v-for="(item, key) in languageList"
              :key="key"
              :label="item"
              :value="key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="tableTitle + '-公开/私有'" prop="private">
          <el-select v-model="newCreateForm.private" placeholder="请选择">
            <el-option value="0" label="公开"></el-option>
            <el-option value="1" label="私有"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.newCreateForm.private === '0' ? false : true"
          :label="tableTitle + '-密码'"
          prop="password"
        >
          <el-input
            placeholder="请输入私有比赛密码"
            v-model="newCreateForm.password"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="this.newCreateForm.private === '0' ? false : true"
          :label="tableTitle + '-用户'"
          prop="ulist"
        >
          <el-input
            type="textarea"
            autosize
            placeholder="请输入用户 多个用户请使用英文逗号隔开"
            v-model="newCreateForm.ulist"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="createEventDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleCreateSubmit('submitForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Editor from "common/wangeditor/Editor";
import DatePicker from "common/datepicker/DatePicker";
import { questionFormRules } from "untils/form_validation.js";
import {
  initMatchList,
  initLanguageList,
  findContests,
  saveContests,
  deleteContests,
  addContests,
  changeContestDefunct,
  downloadLogs,
} from "api/post/postApi.js";
import { getProblemList } from "api/get/getApi.js";
export default {
  name: "oj_match",
  props: {
    tableTitle: {
      type: String,
      default: "竞赛",
    },
    createTitle: {
      type: String,
      default: "新增竞赛",
    },
    theAPI: {
      type: String,
      default: "/v1/contest/list",
    },
    theParames: {
      type: Object,
      default: function () {
        return {
          page:""
        };
      },
    },
    selectDefunct: {
      type: String,
      default: "N", // 未上线为Y
    },
    selectType: {
      type: String,
      default: "1", //比赛1 测验2
    },
  },
  components: {
    Editor,
    DatePicker,
  },
  data() {
    return {
      loading: true,
      tableData: [],
      // 分页功能参数
      total: 0,
      sizes: [10, 20, 30, 40],
      sizePage: 10,
      currentPage: 1,
      selectForm: {
        type: "",
        defunct: "",
        keyword: "",
      },
      EditorDialogVisible: false,
      createEventDialog: false,
      lookDialogVisible: false,
      editorForm: {},
      lookForm: {},
      newCreateForm: {
        private: "0",
        type: "1",
        duration:""
      },
      nowUrl: "",
      ruleFrom: null,
      title: "",
      languageList: null,
      dataPool: null,
      problemList: null,
    };
  },
  created() {
    // 数据初始化
    this.initData();
  },
  mounted() {
    this.initLanguage();
    this.initProblemList();
  },
  // 计算属性
  computed: {
    // 分页控制
    // getTabeData: function () {
    //   const tableData = this.tableData.slice(
    //     (this.currentPage - 1) * this.sizePage,
    //     this.currentPage * this.sizePage
    //   );
    //   return tableData;
    // },
  },
  methods: {
    // 初始化数据
    async initData() {
      const { data: res } = await initMatchList(this.theAPI, this.theParames);
      if (res.status === 0) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
      this.loading = false;
    },
    async initLanguage() {
      const { data: res } = await initLanguageList();
      if (res.status === 0) {
        this.languageList = res.data;
      }
    },
    // 初始化未被添加进比赛的列表
    async initProblemList() {
      const { data: res } = await getProblemList();
      if (res.status === 0) {
        this.dataPool = res.data;
      }
    },
    // 分页功能实现
    // 每页显示
    handleSizeChange(val) {
      this.sizePage = val;
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.theParames.page = val;
      this.initData();
    },
    // 查看
    async handleLookClick(id) {
      this.title = "查看";
      const params = { contest_id: id };
      const { data: res } = await findContests(params);
      this.lookForm = res.data.info;
      // 处理数据 以作数据回显
      let str = "";
      this.lookForm.lang.forEach((item) => {
        str += this.languageList[parseInt(item)];
      });
      this.lookForm.lang = str;
      this.lookDialogVisible = true;
    },
    // 编辑打开
    async editorOpen(id, url, titles) {
      this.title = titles;
      this.ruleFrom = questionFormRules;
      this.nowUrl = url;
      const params = { contest_id: id };
      const { data: res } = await findContests(params);
      if (res.status == 0) {
        this.editorForm = res.data.info;
        this.problemList = res.data.problem_list;
        this.editorForm.private = this.editorForm.private.toString();
        this.editorForm.type = this.editorForm.type.toString();
        this.EditorDialogVisible = true;
        return;
      }
      this.EditorDialogVisible = false;
    },
    // 编辑提交
    async handleEditorSubmit(formName) {
      this.editorForm.lang = this.editorForm.lang.toString();
      this.editorForm.cproblem = this.editorForm.cproblem.toString();
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await saveContests(
            this.nowUrl,
            this.editorForm
          );
          if (res.status !== 0) {
            this.$message.error(res.msg);
          } else {
            this.$message.success("更新成功！");
            this.initData();
          }
          this.EditorDialogVisible = false;
        } else {
          this.$message.error(res.msg);
          this.editorForm.cproblem = null;
          this.editorForm.lang = null;
          return false;
        }
      });
    },
    // 公用的dialog清空逻辑
    closed(formName) {
      this.editorForm = {};
      this.newCreateForm = {
        private: "0",
        type: "1",
      };
      this.resetForm(formName);
    },
    // 删除
    async handleDeleteClick(id) {
      // 询问用户是否删除数据
      const confirmResult = await this.$confirm(
        "此操作将永久删除该信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消删除！");
      }
      const params = { contest_id: id };
      const { data: res } = await deleteContests(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error(res.msg);
      } else {
        this.$message.success("删除成功！");
        this.initData();
      }
    },

    // 新增打开
    createOpen() {
      this.title = "新增";
      this.ruleFrom = questionFormRules;
      this.createEventDialog = true;
    },
    // 提交新增表单
    handleCreateSubmit(formName) {
      this.newCreateForm.cproblem = this.newCreateForm.cproblem.toString();
      this.newCreateForm.lang = this.newCreateForm.lang.toString();
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await addContests(this.newCreateForm);
          if (res.status !== 0) {
            this.$message.error(res.msg);
          } else {
            this.$message.success("新增成功！");
            this.initData();
          }
          this.createEventDialog = false;
        } else {
          this.$message.error(res.msg);
          // 重置表单
          this.newCreateForm.cproblem = null;
          this.newCreateForm.lang = null;
          return false;
        }
      });
    },
    // 表单清除
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 修改上下线状态
    async isDefunct(newID) {
      // 询问用户是否修改状态
      const confirmResult = await this.$confirm(
        "此操作将修改上线状态, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmResult !== "confirm") {
        return this.$message.info("已取消修改！");
      }
      const params = { id: newID };
      const { data: res } = await changeContestDefunct(params);
      if (res.status !== 0) {
        // elementui组件 消息框
        this.$message.error(res.msg);
      } else {
        this.$message.success("修改状态成功！");
        this.initData();
      }
    },
    // 日志下载
    handleLogDClick(id) {
      this.$confirm("此操作将下载该文件日志, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const params = { contest_id: id };
          const { data: res } = await downloadLogs(params);
          if (res.status !== 0) {
            this.$message.error(res.msg);
            return;
          }
          window.location = res.data.download_url;
          this.$message.success("下载成功！");
          // return;
        })
        .catch(() => {
          this.$message.info("已取消下载");
        });
    },
    // 得到时间
    getNowDate(value, form, item) {
      form[item] = value;
    },
    // 得到富文本内容
    editorChange(value, form, item) {
      form[item] = value;
    },
    // 搜索实现
    async onSelect() {
      this.selectForm.defunct = this.selectDefunct;
      this.selectForm.type = this.selectType;
      const { data: res } = await initMatchList(this.theAPI, this.selectForm);
      if (res.status !== 0) {
        this.$message.error(res.msg);
        return;
      }
      this.$message.success("查找成功！");
      this.tableData = res.data.data;
      this.total = res.data.total;
    },
    // 搜索清除
    handleClear() {
      this.selectForm = {};
      this.initData();
    },
  },
};
</script>

<style scoped>
.pages {
  height: 100px;
  width: 100%;
  margin-top: 5px;
  text-align: center;
}
.selects {
  width: 100%;
}
.cratebtn {
  float: right;
}
</style>